// Detects if device is on iOS
const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

// Detects if device is in standalone mode
const isInStandaloneMode = () =>
  "standalone" in window.navigator && window.navigator.standalone;

// Function to check PWA status on iOS and possibly update state
export default function checkPwaIos(setShowPwa) {
  let showPwa = localStorage.getItem("showPwa");
  if (isIos() && !isInStandaloneMode() && showPwa === null) {
    setShowPwa(true);
    localStorage.setItem("showPwa", "true");
  }
}
